import {
  Backdrop, Card, CardHeader, Checkbox, CircularProgress, Divider, FormControl, InputAdornment
  , Paper, Snackbar, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow
  , TableSortLabel, Tabs, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, Slide
} from '@material-ui/core';
import ImagePassIcon from '@material-ui/icons/AddBox';
import QueueIcon from '@material-ui/icons/Queue';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import BarcodeVoice from "src/assets/sound/Bip.mp3";
import axios from "src/utils/axios";
import { getUser } from 'src/utils/Common';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import MaterialDetail from 'src/components/MaterialDetail';
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  container: {
    maxHeight: 500,
    minHeight: 500,
  },
  margin: {
    margin: theme.spacing(1),
  },
  cardScrollUst: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    maxHeight: 450,
    minHeight: 450,
    listStyle: "none",
    height: "100%",
    '&::-webkit-scrollbar': {
      width: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '0px solid slategrey'
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const defaultUyari = { open: false, aciklama: '', tip: 'success' };




function RightPaneUp(props) {

  const [Barcode, setBarcode] = useState("");
  const likeAudio = new Audio(BarcodeVoice);
  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('');
  const [Loading, setLoading] = React.useState(false);

  const [MalzemeArama, setMalzemeArama] = React.useState("");
  const [MaterialCodeParam, setMaterialCodeParam] = React.useState("");
  const [MaterialLeftData, setMaterialLeftData] = React.useState([]);
  const [dataPaslasma, setPaslasmaData] = useState([]);
  const [dataAcikFis, setAcikFisData] = useState([]);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [MaterialDetailPopup, setMaterialDetailPopup] = useState(false);
  const [MaterialHeader, setMaterialHeader] = useState("");
  const [uyariTip, setUyariTip] = useState();
  const headMalzemeleftDataCells = [
    { id: 'MALZEME_STOK_NO', numeric: false, disablePadding: true, label: 'MalzemeKodu' },
    { id: 'MALZEME', numeric: false, disablePadding: true, label: 'Malzeme' }
  ];
  // Uyarı durumu boolean tutuluyor; metin ve tip ayrı state'lerde. Üçü birlikte güncellenir.
  const showUyari = (open, aciklama, tip) => {
    setUyariAciklama(aciklama);
    setUyariTip(tip);
    setUyari(open);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const headStokCells = [
    { id: 'Yer', numeric: false, disablePadding: true, label: 'Yer' },
    { id: 'Adet', numeric: false, disablePadding: true, label: 'Adet' },
  ];
  const [selectedServicePaper, setSelectedServicePaper] = React.useState([]);
  const [selectedMaterial, setSelectedMaterial] = React.useState([]);
  const [selectedQTY, setSelectedQTY] = React.useState([]);

  const [selectedRow, setselectedRow] = useState(-1);
  const [selectedMaterialRow, setselectedMaterialRow] = useState(-1);
  const user = getUser();

  const [Tabvalue, setTabvalue] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    setTabvalue(newValue);
  };
  function ClearAllData() {
    //setMaterialLeftData([]);
    setPaslasmaData([]);
    setAcikFisData([]);
    setMalzemeStokData([]);
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, Header } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {Header.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {/* {order === 'desc' ? '' : ''} */}
                    {''}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const GetMalzemeStokDurumu = (MALZEME_STOK_NO) => {

    axios.get("GetMaterialInfo/" + user.ServiceShopId + "/" + MALZEME_STOK_NO)
      .then(response => {
        setMalzemeStokData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }
  const [MalzemeStokData, setMalzemeStokData] = useState({});

  const postData = {
    ServiceShopId: user.ServiceShopId,
    UserId: user.OrganizationUserId
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // const GetOpenServicePaperMaterial = (BIRIM_KODU, MALZEME_STOK_NO) => {
  //   axios.get("GetOpenServicePaperMaterial/" + BIRIM_KODU + "/" + MALZEME_STOK_NO)
  //     .then(response => {
  //       // console.log(response);
  //       setAcikFisData(response.data);
  //       setLoading(false);
  //     }).catch(error => {
  //       setLoading(false);
  //     });
  // }

  const GetMalzemePaslasma = (MALZEME_STOK_NO, ADET) => {
    axios.get("GetMaterialPass/" + user.ServiceShopId + "/" + MALZEME_STOK_NO + "/" + ADET)
      .then(response => {
        // console.log(response);
        setPaslasmaData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  const GetMaterialLeftSearch = () => {
    setLoading(true);
    axios.get("GetOpenServicePaperMaterial/" + user.ServiceShopId + "/" + MalzemeArama)
      .then(response => {
        if (parseInt(response.data[0].ErrorCode) > 0) {
          setUyariTip('error');
          setUyariAciklama(response.data[0].ErrorDescription);
          setUyari(true);
        } else {
          setAcikFisData(response.data);
        }

        setLoading(false);
      }).catch(error => {

        setLoading(false);
      });

    // axios.get(`MaterialSearchDetail/${MalzemeArama}/Malzeme/${user.ServiceShopId}`)
    //   .then(response => {
    //     var DegerTmp = [];
    //     DegerTmp = response.data;
    //     if (DegerTmp.length > 0) {
    //       var MaterialLeftDataParam = [...MaterialLeftData];
    //       var Varmi = MaterialLeftDataParam.filter(d => d.MALZEME_STOK_NO === MalzemeArama);
    //       if (Varmi.length === 0) {
    //         MaterialLeftDataParam.push(DegerTmp[0]);
    //       }
    //       GetOpenServicePaperMaterial(user.ServiceShopId,MaterialLeftDataParam)
    //       setMaterialLeftData(MaterialLeftDataParam);
    //     }

    //     setLoading(false);
    //   }).catch(error => {
    //     setLoading(false);
    // });
  }
  const [rows, setRows] = React.useState([]);
  const isSelectedServicePaper = (name) => selectedServicePaper.indexOf(name) !== -1;
  const isSelectedMaterial = (name) => selectedMaterial.indexOf(name) !== -1;
  const [isSelectedTmp, setisSelectedTmp] = React.useState("");



  const handleSelectMaterialAllClick = (event) => {
    if (event.target.checked) {
      const newSelectedMaterials = rows.map((n) => n.name);
      setSelectedMaterial(newSelectedMaterials);
      return;
    }
    setSelectedMaterial([]);
  };
  const handleMaterialClick = (event, name) => {
    const selectedMaterialIndex = selectedMaterial.indexOf(name);
    let newSelectedMaterial = [];


    if (selectedMaterialIndex === -1) {
      newSelectedMaterial = newSelectedMaterial.concat(selectedMaterial, name);
    } else if (selectedMaterialIndex === 0) {
      newSelectedMaterial = newSelectedMaterial.concat(selectedMaterial.slice(1));
    } else if (selectedMaterialIndex === selectedMaterial.length - 1) {
      newSelectedMaterial = newSelectedMaterial.concat(selectedMaterial.slice(0, -1));
    } else if (selectedMaterialIndex > 0) {
      newSelectedMaterial = newSelectedMaterial.concat(
        selectedMaterial.slice(0, selectedMaterialIndex),
        selectedMaterial.slice(selectedMaterialIndex + 1),
      );
    }
    setSelectedMaterial(newSelectedMaterial);
    setisSelectedTmp("");
  };
  const handleServicePaperClick = (event, name) => {

    const selectedServicePaperIndex = selectedServicePaper.indexOf(name);
    let newSelectedServicePaper = [];


    if (selectedServicePaperIndex === -1) {
      newSelectedServicePaper = newSelectedServicePaper.concat(selectedServicePaper, name);
    } else if (selectedServicePaperIndex === 0) {
      newSelectedServicePaper = newSelectedServicePaper.concat(selectedServicePaper.slice(1));
    } else if (selectedServicePaperIndex === selectedServicePaper.length - 1) {
      newSelectedServicePaper = newSelectedServicePaper.concat(selectedServicePaper.slice(0, -1));
    } else if (selectedServicePaperIndex > 0) {
      newSelectedServicePaper = newSelectedServicePaper.concat(
        selectedServicePaper.slice(0, selectedServicePaperIndex),
        selectedServicePaper.slice(selectedServicePaperIndex + 1),
      );
    }
    setSelectedServicePaper(newSelectedServicePaper);

  };

  const handleQTYClick = (event, name) => {

    const selectedQTYIndex = selectedQTY.indexOf(name);
    let newSelectedQTY = [];


    if (selectedQTYIndex === -1) {
      newSelectedQTY = newSelectedQTY.concat(selectedQTY, name);
    } else if (selectedQTYIndex === 0) {
      newSelectedQTY = newSelectedQTY.concat(selectedQTY.slice(1));
    } else if (selectedQTYIndex === selectedQTY.length - 1) {
      newSelectedQTY = newSelectedQTY.concat(selectedQTY.slice(0, -1));
    } else if (selectedQTYIndex > 0) {
      newSelectedQTY = newSelectedQTY.concat(
        selectedQTY.slice(0, selectedQTYIndex),
        selectedQTY.slice(selectedQTYIndex + 1),
      );
    }
    setSelectedQTY(newSelectedQTY);

  };

  function AddPass(row, index) {


    var CardControl = 0;

    axios.get("GetTokenPayCardControl/" + user.ServiceShopId + "/" + user.TokenPayId)
      .then(response => {
        CardControl = response.data;

        if (parseInt(CardControl) === 1) {
          var ConfirmAlert = '';
          var PayorTypeCode = 1;
          const isCountingPeriodActivated = sessionStorage.getItem("isCountingPeriod");
          // Bu kod sayım dönemi bitince açılacak ve üsteki kapatılacak.
          if ((parseInt(MalzemeStokData.MERKEZ) + parseInt(MalzemeStokData.BOLGE) > 10) && parseInt(isCountingPeriodActivated) === 0) {
            ConfirmAlert = 'Paslaşma talebi yaptığınız malzeme Arçelik stoklarında olduğundan, Oluşacak Kargo bedelinin tarafınızdan karşılanması gerekecektir!.... Devam etmek istediğinzden eminmisiniz?'
            PayorTypeCode = 2;
          } else {
            ConfirmAlert = 'Seçili olan malzeme için talep açılacaktır. Devam etmek istediğinzden eminmisiniz?';
          }
          confirmAlert({
            message: ConfirmAlert,
            buttons: [
              {
                label: 'Evet',
                onClick: () => AddPassKabul(row, index, PayorTypeCode)
              },
              {
                label: 'Hayır',
                onClick: () => {
                  return;
                }
              }
            ]
          });

        } else {
          var CardAlert = "Kredi kartınız sistemimize kayıtlı değil. Kartınızı kaydettikten sonra 1 TL'lik geri ödemeli işlem yapılacaktır. Devam etmek istediğinize emin misiniz?";
          confirmAlert({
            message: CardAlert,
            buttons: [
              {
                label: 'Evet',
                onClick: () => SetCardUrl(row, index)
              },
              {
                label: 'Hayır',
                onClick: () => {
                  return;
                }
              }
            ]
          });
        }

      }).catch(error => {
        setLoading(false);
      });
  }

  function SetCardUrl(row, index) {

    //serdr
    const today = moment(new Date()).format('DD.MM.YYYY');
    const data = [{
      conversationId: user.ServiceShopCode + today.toString(),
      price: 1,
      paidPrice: 1,
      installment: 1,
      currency: "TRY",
      paymentGroup: "PRODUCT",
      callbackUrl: "NO_CALLBACK_URL", //bURASI NASIL YAPILACAK SORULACAK.
      items: [
        {
          externalId: user.ServiceShopCode,
          name: "KART KAYIT",
          price: 1,
          subMerchantId: user.TokenPayId,
          subMerchantPrice: 1
        }
      ]
    }
    ]

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/PostTokenPayUrl', data, config)
      .then(response => {
        setLoading(false);
        window.open(response.data);
      }).catch(error => {
        showUyari(true, 'Bir hata oluştu!..' + error.message, 'error');
        setLoading(false);
      });



  }

  function AddPassKabul(row, index, PayorTypeCode, TekrarOnay = false) {

    if (selectedServicePaper === "") {
      showUyari(true, 'Lütfen Fiş Seçiniz!', 'error');
      return;
    }
    showUyari(false, '', 'success');
    const data = {
      MALZEME_STOK_NO: row.MALZEME_STOK_NO,
      FIS_NO: selectedServicePaper,
      TALEP_BIRIM_KODU: user.ServiceShopId,
      ADET: selectedQTY,
      ARZ_BIRIM_KODU: row.BIRIM_KODU,
      TALEP_KULLANICI: user.UserId,
      PayorTypeCode: PayorTypeCode,
      TEKRAR_ONAY: TekrarOnay
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetMaterialPass', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          var dataPaslasmaParam = [...dataPaslasma];
          dataPaslasmaParam.splice(index, 1);
          setPaslasmaData(dataPaslasmaParam);
          showUyari(true, 'İşlem başarılı', 'success');
        } else if (response.data.ErrorCode === "2") {
          // Aynı fiş + malzeme için onaylanmış paslaşma var; kullanıcı onaylarsa kayıt tekrar onayla açılır.
          confirmAlert({
            message: response.data.ErrorDescription,
            buttons: [
              {
                label: 'Evet',
                onClick: () => AddPassKabul(row, index, PayorTypeCode, true)
              },
              {
                label: 'Hayır',
                onClick: () => {
                  return;
                }
              }
            ]
          });
        } else {
          showUyari(true, response.data.ErrorDescription, 'error');
        }
        setLoading(false);
      }).catch(error => {
        showUyari(true, 'Bir hata oluştu!..' + error.message, 'error');
        setLoading(false);
      });
  }
  const [imageProps, setImageProps] = useState({ open: false, materialCode: null, materialDesc: '' });

  const [pagination, setPagination] = useState({ page: 0, rowsPerPage: 10 });

  const classes = useStyles();


  const handleClick = (event, row, index) => {
    if (row.RowSelected === 0) {
      row.RowSelected = 1;
    } else {
      row.RowSelected = 0;
    }
    let dataAcikFisYedek = [...dataAcikFis];
    setAcikFisData(dataAcikFisYedek);
  };

  const GetMaterialDetailPopup = (MaterialCode, Material) => {
    setMaterialCodeParam(MaterialCode);
    setMaterialHeader(MaterialCode + ' ' + Material);

    setMaterialDetailPopup(true);

  }


  return (

    <Paper>
      <CardHeader title="Paslaşma İşlemleri" />
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={uyariKapat}>
        <Alert onClose={uyariKapat} severity={uyariTip}>
          {uyariAciklama || ''}
        </Alert>
      </Snackbar>
      <Divider />
      <Card style={{ height: 570, width: '100%' }}>
        <Tabs value={Tabvalue}
          textColor="secondary"
          scrollButtons="on"
          indicatorColor="primary"
          variant="scrollable"
          onChange={handleTabChange}>
          <Tab label="Malzeme Arama" />
          <Tab label="Stok Durumu" />
          <Tab label="Paslaşma" />
        </Tabs>
        <TabPanel value={Tabvalue} index={0}>
          <FormControl fullWidth className={classes.margin}>
            <TextField
              label="Malzeme Araması Yapınız!..."
              id="standard-start-adornment"
              className={clsx(classes.margin, classes.textField)}

              onKeyPress={event => {
                if (event.key === 'Enter') {
                  GetMaterialLeftSearch();
                  handleMaterialClick(event, event.target.value);
                  //GetMalzemePaslasma(event.target.value,1);
                  //GetMalzemeStokDurumu(event.target.value);
                }
              }}
              onChange={event => { ClearAllData(); setMalzemeArama(event.target.value); }}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <QueueIcon
                      onClick={(event) => { ClearAllData(); GetMaterialLeftSearch(); }}
                      color="primary"
                    />
                  </InputAdornment>,
              }}
            />
          </FormControl>
          <TableContainer style={{ maxHeight: 400, minHeight: 400, width: '100%' }} className={classes.cardScrollUst}>
            <Table
              stickyHeader
              aria-labelledby="tableTitle"
              size={'small'}
            >
              <TableHead>
                <TableRow>
                  <TableCell align="left">Seç</TableCell>
                  <TableCell align="left">Detay</TableCell>
                  <TableCell align="left">Malzeme Stok No</TableCell>
                  <TableCell align="left">Açıklama</TableCell>
                  <TableCell align="left">Adet</TableCell>
                  <TableCell align="left">Malzeme bekleyen Fişler</TableCell>
                  <TableCell align="left">Açık Gün</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stableSort(dataAcikFis, getComparator(order, orderBy))
                  .map((row, index) => {
                    const isItemSelectedMaterial = isSelectedMaterial(row.MALZEME_STOK_NO);
                    const labelMaterialId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow
                        hover
                        onClick={event => { setSelectedQTY(row.ADET); setSelectedServicePaper(row.FIS_NO); handleMaterialClick(event, row.MALZEME_STOK_NO); GetMalzemePaslasma(row.MALZEME_STOK_NO, row.ADET); GetMalzemeStokDurumu(row.MALZEME_STOK_NO); }}
                        role="checkbox"
                        aria-checked={isItemSelectedMaterial}
                        tabIndex={-1}
                        key={row.MALZEME_STOK_NO}
                        selected={isItemSelectedMaterial}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={row.RowSelected === 0 ? false : true}
                            color="primary"
                            onClick={event =>
                              handleClick(event, row, index)
                            }
                            inputProps={{ 'aria-labelledby': labelMaterialId }}
                          />
                        </TableCell>
                        <TableCell align="left" className={classes.tableCell}>
                          <SearchIcon
                            onClick={(event) => { GetMaterialDetailPopup(row.MALZEME_STOK_NO, row.MALZEME); }}
                            color="primary"
                          />

                        </TableCell>
                        <TableCell align="left" className={classes.tableCell}>
                          {row.MALZEME_STOK_NO}
                        </TableCell>
                        <TableCell align="left" title={row.MALZEME} className={classes.tableCell}>
                          {row.MALZEME.substring(0, 15)}...
                        </TableCell>
                        <TableCell align="left" title={row.MALZEME} className={classes.tableCell}>
                          {row.ADET}
                        </TableCell>
                        <TableCell align="left" >
                          {row.FIS_NO}
                        </TableCell>
                        <TableCell align="left" >
                          {row.SURE}
                        </TableCell>
                      </TableRow>
                    );
                  })}

              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <TabPanel value={Tabvalue} index={1}>
          <TableContainer style={{ maxHeight: 400, minHeight: 400, width: '100%' }}>
            <Table
              stickyHeader
              className={classes.table}
              aria-labelledby="tableTitle"
              size={'small'}>
              <EnhancedTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                Header={headStokCells}
              />
              <TableBody>
                {[{ id: "SERVIS", label: "Servis" }, { id: "BOLGE", label: "Bölge" }, { id: "MERKEZ", label: "Merkez" }, { id: "TEMIN_TARIHI", label: "Temin Tarihi" }].map((m, i) =>
                  <TableRow key={i}>
                    <TableCell align="left" className={classes.tableCell}>
                      {m.label}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {MalzemeStokData[m.id]}
                    </TableCell>
                  </TableRow>
                )
                }
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <TabPanel value={Tabvalue} index={2}>
          <Snackbar open={uyari.open} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyari.tip}>
              {uyari.aciklama || ''}
            </Alert>
          </Snackbar>
          <TableContainer style={{ maxHeight: 400, minHeight: 400 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Stok No</TableCell>
                  <TableCell align="left">Açıklama</TableCell>
                  <TableCell align="left">SatışFiyatı</TableCell>
                  <TableCell align="left">Adet</TableCell>
                  <TableCell align="left">Servisİl</TableCell>
                  <TableCell align="left">Servis</TableCell>
                  <TableCell align="left">DepoTelefon</TableCell>
                  <TableCell align="left">Email</TableCell>
                  <TableCell align="left">TalepAç</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataPaslasma.slice(pagination.page * pagination.rowsPerPage, (pagination.page + 1) * pagination.rowsPerPage).map((row, index) => (
                  <TableRow key={index}>

                    <TableCell align="left" >
                      {row.MALZEME_STOK_NO}
                    </TableCell>
                    <TableCell align="left" >
                      {row.MALZEME_ACIKLAMA}
                    </TableCell>
                    <TableCell align="left" title={row.Maktx}>
                      {parseInt(row.MALZEME_KDVLI_FIYAT) > 0 ? parseInt(row.MALZEME_KDVLI_FIYAT).toFixed(2) + " ₺" : "0 ₺"}
                    </TableCell>
                    <TableCell align="left" title={row.Maktx}>
                      {row.ADET}
                    </TableCell>
                    <TableCell align="left" title={row.Maktx}>
                      {row.ILETISIM_IL}
                    </TableCell>
                    <TableCell align="left" title={row.Maktx}>
                      {row.SERVIS}
                    </TableCell>
                    <TableCell align="left" title={row.Maktx}>
                      {row.TEL1}
                    </TableCell>
                    <TableCell align="left" >
                      {row.EMAIL}
                    </TableCell>
                    <TableCell align="left">
                      <ImagePassIcon
                        onClick={() => AddPass(row, index)}
                        color="primary" />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={dataPaslasma.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            onChangePage={(e, v) => setPagination({ ...pagination, page: v })}
            onChangeRowsPerPage={e => setPagination({ page: 0, rowsPerPage: e.target.value })}
          />

        </TabPanel>
      </Card>
      <Dialog
        fullWidth
        maxWidth={'xl'}
        open={MaterialDetailPopup}
        onClose={() => setMaterialDetailPopup(false)}
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          {MaterialHeader} Malzeme Detayı
        </DialogTitle>
        <DialogContent>
          {MaterialCodeParam ? <MaterialDetail MaterialParam={MaterialCodeParam} /> : ""}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setMaterialDetailPopup(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (

        <Typography>{children}</Typography>

      )}
    </div>
  );
}



TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default RightPaneUp;
